// ----------------------------------------------------------------------

import { alpha } from '@mui/material/styles';

export default function Tabs(theme) {
  return {
    MuiTabs: {
      styleOverrides: {
        root: {
          minHeight: 48,
        },
        indicator: {
          height: 3,
          borderRadius: '3px 3px 0 0',
          background: theme.gradients?.primary || 'linear-gradient(90deg, #A8469B 0%, #569cd3 100%)',
        },
        scrollButtons: {
          width: 48,
          '&.Mui-disabled': {
            opacity: 0.3,
          },
        },
      },
      variants: [
        // Gradient Tabs Variant
        {
          props: { variant: 'gradient' },
          style: {
            '& .MuiTabs-indicator': {
              height: 4,
              background: theme.gradients?.primary || 'linear-gradient(90deg, #A8469B 0%, #569cd3 100%)',
              boxShadow: `0 2px 8px ${alpha('#A8469B', 0.3)}`,
            },
          },
        },
        // Pills Variant
        {
          props: { variant: 'pills' },
          style: {
            '& .MuiTabs-indicator': {
              display: 'none',
            },
            '& .MuiTab-root': {
              margin: theme.spacing(0, 0.5),
              borderRadius: theme.shape.borderRadius * 2,
              '&.Mui-selected': {
                background: theme.gradients?.primary || 'linear-gradient(135deg, #A8469B 0%, #569cd3 100%)',
                color: '#fff',
              },
            },
          },
        },
      ],
    },
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 600,
          fontSize: '0.95rem',
          minHeight: 48,
          padding: theme.spacing(1.5, 3),
          color: theme.palette.text.secondary,
          transition: 'all 0.3s ease',
          '&:hover': {
            color: theme.palette.primary.main,
            backgroundColor: alpha(theme.palette.primary.main, 0.05),
          },
          '&.Mui-selected': {
            color: '#A8469B',
            fontWeight: 700,
          },
          '&.Mui-disabled': {
            opacity: 0.5,
          },
        },
        labelIcon: {
          minHeight: 56,
          paddingTop: theme.spacing(1.5),
          '& > *:first-of-type': {
            marginBottom: theme.spacing(0.75),
          },
        },
        wrapped: {
          padding: theme.spacing(1, 2),
        },
      },
      variants: [
        // Glass Tab Variant
        {
          props: { variant: 'glass' },
          style: {
            '&.Mui-selected': {
              background: alpha('#fff', 0.15),
              backdropFilter: 'blur(10px)',
              WebkitBackdropFilter: 'blur(10px)',
              border: `1px solid ${alpha('#fff', 0.2)}`,
              borderRadius: theme.shape.borderRadius,
            },
          },
        },
      ],
    },
  };
}
